class SideDrawerToggle extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", function (evt) {
      evt.preventDefault();

      if (this.getAttribute("data-drawer") == "all") {
        closeActiveDrawers();

      } else {
        const drawer = document.getElementById(
          this.getAttribute("data-drawer")
        );

        var drawerActive = false;

        if (this.classList.contains("drawers-close-active")) {
          drawerActive = drawer.classList.contains('active');
          closeActiveDrawers();
        }

        //dispatch event to trigger drawer state
        if (!drawerActive) {
          drawer.dispatchEvent(new Event("drawer-toggle"));


          if (this.getAttribute('data-drawer-top')) {
            document.body.classList.add("shadow--top");
          }
        }
      }

      document.dispatchEvent(new CustomEvent('searchDiscovery:close'));

      if (document.getElementById('drawer-mobile-navigation').classList.contains('active')) {
        document.querySelector('header.header').classList.add('active');
      } else {
        document.querySelector('header.header').classList.remove('active');
      }
    });

    function closeActiveDrawers() {
      const activeDrawers = document.querySelectorAll("side-drawer.active");
      if (activeDrawers) {
        activeDrawers.forEach((el) => {
          //Toggle drawer event
          el.dispatchEvent(new Event("drawer-toggle"));
        });
      }
    }
  }
}

customElements.define("side-drawer-toggle", SideDrawerToggle);